import React from 'react';

import SciUnsubscribers from '../../components/Communication/Unsubscribers/SciUnsubscribers.module';

function SciUnsubscribersView() {
  return (
    <SciUnsubscribers />
  );
}

export default SciUnsubscribersView;


